module.exports = __webpack_public_path__ + "img/opp4.9ad89790.png";